module.exports = __webpack_public_path__ + "img/slide2.69179622.png";